import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const CATEGORIES = [
  ["Fassbier", "Fassbier"],
  ["Flaschenbier", "Flaschenbier"],
  ["AF", "Alkoholfrei (Saft/Soda)"],
  ["AF Fl", "Alkoholfrei (Flaschen)"],
  ["Heißgetränke", "Heißgetränke"],
  ["Wein offen", "Wein offen"],
  ["Wein FL", "Wein Flaschen"],
  ["Cocktails", "Cocktails"],
  ["Mix", "Mix/Longdrinks"],
  ["Mix Fl", "Mix Flaschen"],
  ["Spirituosen", "Spirituosen"],
  ["Spirituosen FL", "Spirituosen Flaschen"],
  ["Pizza", "Pizza"],
  ["Baguettes", "Baguettes"],
  ["Snack", "Snacks"],
  ["Tabak", "Tabak"],
  ["Billard", "Billard/Spiele"],
];

export function PricelistForm({ formData, f }) {
  return (
    <>
      <div>
        <Label className="text-sm">Kategorie</Label>
        <Select value={formData.category || "Fassbier"} onValueChange={v => f("category", v)}>
          <SelectTrigger className="mt-1 bg-input/50 border-white/10 rounded-none"><SelectValue /></SelectTrigger>
          <SelectContent>
            {CATEGORIES.map(([val, label]) => (
              <SelectItem key={val} value={val}>{label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div><Label className="text-sm">Name</Label><Input value={formData.name || ""} onChange={e => f("name", e.target.value)} className="mt-1 bg-input/50 border-white/10 rounded-none" data-testid="dialog-name" /></div>
      <div><Label className="text-sm">Beschreibung</Label><Input value={formData.description || ""} onChange={e => f("description", e.target.value)} className="mt-1 bg-input/50 border-white/10 rounded-none" /></div>
      <div className="grid grid-cols-2 gap-3">
        <div><Label className="text-sm">Preis (EUR)</Label><Input type="number" step="0.1" value={formData.price || ""} onChange={e => f("price", parseFloat(e.target.value))} className="mt-1 bg-input/50 border-white/10 rounded-none" data-testid="dialog-price" /></div>
        <div><Label className="text-sm">Reihenfolge</Label><Input type="number" value={formData.sort_order || 0} onChange={e => f("sort_order", parseInt(e.target.value))} className="mt-1 bg-input/50 border-white/10 rounded-none" /></div>
      </div>
    </>
  );
}
